import { Search } from "@mui/icons-material"
import { Box } from "@mui/material"
import { AppContext } from "contexts/AppContext"
import { useContext } from "react"
import { translate } from "utils/Translate"

export function SearchBar(){
  const {searchInput, setSearchInput, styleGuide, brandData} = useContext(AppContext)

  const searchBarBackgroundColor = brandData?.features?.searchBarBackgroundColor || styleGuide.color3
  const searchBarLabelColor = brandData?.features?.searchBarLabelColor || styleGuide.color5

  const inputStyle = {
    borderBottom: `1px solid ${styleGuide.color7}`,
    "&:focus-within": {
      borderBottom: `1px solid ${styleGuide.color16}`,
    },
  }

  return (
    <Box display={'flex'} flexGrow={1} justifyContent={'center'}>
      <Box
        display={'flex'}
        alignItems={'center'}
        backgroundColor={searchBarBackgroundColor}
        border={'none'}
        borderRadius={'14px'}
        padding={'12px 16px'}
        width={350}
        gap={1}
      >
        <Search sx={{ color: searchBarLabelColor }} />
        <Box sx={inputStyle} flex={1}>
          <input
            autoFocus
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            placeholder={translate('_SHOP_SEARCH_LABEL_', 'Søg')}
            style={{
              width: "100%",
              backgroundColor: searchBarBackgroundColor,
              border: "none",
              outline: 'none',
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}